import './Partners.css';

// Importy wszystkich logotypów
import ujLogo from '../../../assets/logos/uj.svg';
import bmbfLogo from '../../../assets/logos/bmbf.svg';
import maxPlanckLogo from '../../../assets/logos/max_planck.svg';
import ncnLogo from '../../../assets/logos/ncn_logo.svg';
import dioscuriLogo from '../../../assets/logos/dioscuri_logo.svg';
import moeasLogo from '../../../assets/logos/moeas_logo.svg';
import mniswLogo from '../../../assets/logos/mnisw_logo.svg';

export default function Partners() {

    // Wszystkie logotypy należą teraz do jednej grupy
    const organizers = [
        {
            name: 'Jagiellonian University',
            logo: ujLogo
        },
        {
            name: 'Ministry of Science and Higher Education',
            logo: mniswLogo
        },
        {
            name: 'National Science Centre',
            logo: ncnLogo
        },
        {
            name: 'Federal Ministry of Education and Research',
            logo: bmbfLogo
        },
        {
            name: 'Max Planck Society',
            logo: maxPlanckLogo
        },
        {
            name: 'Dioscuri Centre',
            logo: dioscuriLogo
        },
    ];

    const renderItems = (items) => items.map(item => `
        <div class="partners__item">
            <div class="partners__logo-box">
                <img
                    src="${item.logo}"
                    alt="${item.name}"
                    class="partners__logo"
                >
            </div>
        </div>
    `).join('');

    return `
        <section class="partners" id="partners">
            <div class="partners__container">

                <div class="partners__header">
                    <span class="partners__eyebrow">
                    </span>

                    <h2 class="partners__title">
                        Organizers & Partners
                    </h2>
                </div>

                <div class="partners__group">

                    <div class="partners__label">
                        
                    </div>

                    <div class="partners__logos partners__logos--organizers">
                        ${renderItems(organizers)}
                    </div>

                </div>

            </div>
        </section>
    `;
}
